<div class="modal-header">
    <h5 class="modal-title">Change your password</h5>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <iframe id="change-password-content" scrolling="no" src="/uua/change_password/"> </iframe>
</div>
